import { BusinessUser } from 'src/app/model/user';
import { Injectable } from '@angular/core';
import { Booking } from './model/booking';
import { DeliveryOption } from './model/deliveryOption';
import { Property } from './model/property';
import { TaxDetails } from './model/TaxDetails';
import { PropertyServiceDTO } from './model/PropertyServices';
import { Room } from './model/room';


const PROPERTY = 'Property';
const PROPERTY_NAME = 'PropertyName';
const BOOKINGDATA = 'booking';
const BUSINESSUSER = 'business';
const PRODUCT_CART = 'productCart';
const DELIVERY_OPTION = 'delivery_option';
const SELECTED_COUNTRY = 'selectedCountry';
const PROPERTY_DETAILS = 'PROPERTY_DETAILS';
const PROPERTY_URL = 'PropertyUrl';
const BOOKINGCITY = 'bookingCity';
const ROOMSDATA = 'roomsData';
const WEBSITE_BOOKING_URL ='websitebookingURL';
const SELECTED_SERVICE_DATA = 'SELECTED_SERVICE_DATA';
const BOOKINGROOMPRICE = 'bookingPrice';
const PROPERTY_SERVICE_DATA = 'PROPERTY_SERVICE_DATA';
const CHECK_BOOKING_ENGINE ='checkbookingengine';
const BOOKROOMPRICE = 'bookRoomPrice';
const BOOKINGDATAONE = 'bookingOne';

@Injectable()
export class TokenStorage {
  savePaymentData: any;
  savePropertyData(businessUser: BusinessUser) {
    throw new Error("Method not implemented.");
  }
  getFromTime(): any {
    throw new Error("Method not implemented.");
  }
  getToTime(): any {
    throw new Error("Method not implemented.");
  }
  // savePropertyUrl: any;
  // getBookingCity: any;
  saveBookingEngineBoolean: any;
  // getRoomsData: any;
  savewebsitebookingURL: any;
  // getwebsitebookingURL: any;
  // getSelectedServices: any;
  // saveBookingRoomPrice: any;
  saveSelectedServices: any;
  // saveServiceData: any;
  saveBookingCity: any;
  clearwebsitebookingURL() {
    throw new Error('Method not implemented.');
  }
  getCountry() {
    throw new Error('Method not implemented.');
  }
  constructor() {}

  signOut() {
    window.sessionStorage.removeItem(PROPERTY_NAME);
    window.sessionStorage.clear();
  }

  public saveProperty(property: Property) {
    window.sessionStorage.removeItem(PROPERTY);
    window.sessionStorage.setItem(PROPERTY, JSON.stringify(property));
  }

  public getBookingEngineBoolean() {
    return sessionStorage.getItem(CHECK_BOOKING_ENGINE);
  }

  public getBookingCity() {
    return localStorage.getItem(BOOKINGCITY);
  }
  public savePropertyOne(property: BusinessUser) {
    localStorage.removeItem(PROPERTY_DETAILS);
      if (property !== null) {
      localStorage.setItem(PROPERTY_DETAILS, JSON.stringify(property));
      } else {
      localStorage.setItem(PROPERTY_DETAILS,  '{}');
      }
    }

  public getProperty(): Property {
    return JSON.parse(sessionStorage.getItem(PROPERTY));
  }

  public getServiceData(): PropertyServiceDTO[] {
    return JSON.parse(localStorage.getItem('PropertyServiceDTO') as string);
  }

  public savePropertyName(name: string) {
    window.sessionStorage.removeItem(PROPERTY_NAME);
    window.sessionStorage.setItem(PROPERTY_NAME, name);
  }
  // Booking
  public saveBookingData(booking: Booking) {
    window.localStorage.removeItem(BOOKINGDATA);
    if (booking !== null || booking !== undefined) {
      window.localStorage.setItem(BOOKINGDATA, JSON.stringify(booking));
    } else {
      window.localStorage.setItem(BOOKINGDATA, null);
    }
  }
  public getBookingData(): Booking {
    return JSON.parse(sessionStorage.getItem(BOOKINGDATA));
  }
  public getPropertyName(): string {
    return sessionStorage.getItem(PROPERTY_NAME);
  }

  public saveRoomPrice(bookRoomPrice: number) {
    localStorage.removeItem(BOOKROOMPRICE);
    if (bookRoomPrice !== null && bookRoomPrice !== undefined) {
      localStorage.setItem(BOOKROOMPRICE, bookRoomPrice.toString());
    } else {
      localStorage.setItem(BOOKROOMPRICE, '{}');
    }
  }
  public getRoomPrice() {
    return localStorage.getItem(BOOKROOMPRICE);
  }
  
  public getRoomsData(): Room[] {
    return JSON.parse(localStorage.getItem(ROOMSDATA) as string);
  }

  clearHotelBooking() {
    window.sessionStorage.removeItem(BOOKINGDATA);
  }


// ProductCart
clearProductCart() {
  window.sessionStorage.removeItem(PRODUCT_CART);
}

public saveProductCart(product: any[]) {
  window.sessionStorage.removeItem(PRODUCT_CART);
  if (product !== null || product !== undefined) {
    window.sessionStorage.setItem(PRODUCT_CART, JSON.stringify(product));
  } else {
    window.sessionStorage.setItem(PRODUCT_CART, null);
  }
}
public getPropertyOne(): BusinessUser {
  return JSON.parse(localStorage.getItem(PROPERTY_DETAILS) as string);
}
public getProductCart() {
  return JSON.parse(sessionStorage.getItem(PRODUCT_CART));
}
public saveBookingDataOne(booking: Booking) {
  localStorage.removeItem(BOOKINGDATAONE);
    if (booking !== null || booking !== undefined) {
    localStorage.setItem(BOOKINGDATAONE, JSON.stringify(booking));
    } else {
    localStorage.setItem(BOOKINGDATAONE,  '{}');
    }
  }
// delivery option

public saveDeliveryOption(deliveryOption: DeliveryOption){

  window.sessionStorage.removeItem(DELIVERY_OPTION);
  if (deliveryOption !== null || deliveryOption !== undefined) {
    window.sessionStorage.setItem(DELIVERY_OPTION, JSON.stringify(deliveryOption));
  } else {
    window.sessionStorage.setItem(DELIVERY_OPTION, null);
  }
}
public saveSelectedCountry(countryCode: string) {
  window.localStorage.setItem(SELECTED_COUNTRY, countryCode);
}

public getDeliveryOption(): DeliveryOption {
  return JSON.parse(sessionStorage.getItem(DELIVERY_OPTION));
}
public getwebsitebookingURL() {
  return localStorage.getItem(WEBSITE_BOOKING_URL);
}


  // PROPERTY_SERVICE_DATA
  public saveServiceData(propertyServiceDTO: PropertyServiceDTO[]) {
    localStorage.removeItem(PROPERTY_SERVICE_DATA);
      if (propertyServiceDTO !== null || propertyServiceDTO !== undefined) {
      localStorage.setItem(
          PROPERTY_SERVICE_DATA,
          JSON.stringify(propertyServiceDTO)
        );
      } else {
      localStorage.setItem(PROPERTY_SERVICE_DATA, '{}');
      }
    }

public saveBookingRoomPrice(roomPrice: number) {
  localStorage.removeItem(BOOKINGROOMPRICE);
  if (roomPrice !== null && roomPrice !== undefined) {
    localStorage.setItem(BOOKINGROOMPRICE, roomPrice.toString());
  } else {
    localStorage.setItem(BOOKINGROOMPRICE, '{}');
  }
}
public getBookingRoomPrice() {
  return localStorage.getItem(BOOKINGROOMPRICE);
}


getTaxDetails(businessService : any , property : BusinessUser)
{

  if(businessService.taxDetails != null && businessService.taxDetails != undefined && businessService.taxDetails.length > 0)
  {
    let taxDetails = businessService.taxDetails[0].taxSlabsList;
    if(taxDetails != null && taxDetails != undefined && businessService.taxDetails.length > 0)
    {
      return businessService.taxDetails;
    }
  }
  else
  {
    let taxDetails= property.taxDetails[0].taxSlabsList;
    if(taxDetails != null && taxDetails != undefined && property.taxDetails.length > 0)
    {
      return property.taxDetails;
    }
  }

}


getSelectedServices() {
  // return JSON.parse(sessionStorage.getItem('selectedServices') );
return JSON.parse(sessionStorage.getItem(SELECTED_SERVICE_DATA) as string);


}

public savePropertyUrl(PropertyUrl: string) {
  window.sessionStorage.removeItem(PROPERTY_URL);
  window.sessionStorage.setItem(PROPERTY_URL, PropertyUrl);
}
getTaxPercentageByTaxDetail(amount : number ,taxdetails : TaxDetails)
  {
      if(taxdetails != null && taxdetails != undefined)
      {
       let taxSlabList = taxdetails.taxSlabsList;
       if(taxSlabList != null && taxSlabList  != undefined && taxSlabList.length > 0)
       {
         let sizeOfTaxArray = taxSlabList.length;
         for (let i = 0; i < sizeOfTaxArray; i++)
          {
            let minAmount = taxSlabList[i].minAmount;
            let maxAmount= taxSlabList[i].maxAmount;
            let taxSlab= taxSlabList[i];
             if(amount >= minAmount  && amount <= maxAmount)
             {
               return taxSlab.percentage ;
               break;
             }

          }
       }
       else
       {
          return taxdetails.percentage;
       }
      }

  }
}
